import { dataCouponPercent } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCouponPercent = /*#__PURE__*/createIcon(dataCouponPercent)
export default IconCouponPercent
